import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@mui/material/styles';

import App from './App';
import theme from './theme';
import './App.css';

// 🔹 Importa o provider de tradução
import { I18nProvider } from './i18n/I18nContext';

ReactDOM.render(
  <React.StrictMode>
    {/* 🔹 Envolve TUDO com o I18nProvider */}
    <I18nProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </I18nProvider>
  </React.StrictMode>,
  document.getElementById('root')
);